import React from 'react';
import type { ReactNode } from 'react';

type UserRole = 'admin' | 'qa_lead' | 'qa_tester' | 'qa_automation' | 'viewer';

interface RoleGuardProps {
    children: ReactNode;
    allowed: UserRole[];
    fallback?: ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ children, allowed, fallback = null }) => {
    const userStr = localStorage.getItem('user');

    // If no user, deny (or handle as guest if needed, but here we assume auth)
    if (!userStr) return <>{fallback}</>;

    try {
        const user = JSON.parse(userStr);
        const userRole = user.role as UserRole; // Assuming backend sends 'role'

        if (allowed.includes(userRole)) {
            return <>{children}</>;
        } else {
            return <>{fallback}</>;
        }
    } catch (e) {
        console.error("Error parsing user from local storage", e);
        return <>{fallback}</>;
    }
};

export default RoleGuard;
